<template>
    <article class='xbed-oms-content'>
        <Spin size="large" v-if="spinShow"></Spin>
        <section class='xbed-sub-title'>
            <span>订单详情</span>
        </section>
        <section style='marginTop:20px'>
            <Form :model='transactionListData' ref='orderDetail'>
                <Row>
                    <Col span='12'>
                        <FormItem prop='' label='订单号：' :label-width='120'>
                            <div>{{transactionListData.outOrderId}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='创建时间：' :label-width='120'>
                            <div>{{transactionListData.ctime}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='订单状态：' :label-width='120'>
                            <div>{{['待支付','待入住','已完成','已取消'][transactionListData.status]}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='预定渠道：' :label-width='120'>
                            <div>{{transactionListData.sourceType}}</div>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span='3' offset="1" v-if='isShowCancelBtn'>
                        <FormItem >
                            <Button type='error' :disabled='transactionListData.isCanClick' @click='openCancelOrder'>取消订单</Button>
                        </FormItem>
                    </Col>
                    <Col span='3' offset="0">
                        <FormItem>
                            <Button type='primary' @click='openContral'>操作记录</Button>
                        </FormItem>
                    </Col>
                </Row>
                <div class='page-title'>
                    <span>基本信息</span>
                </div>
                <Row>
                    <Col span='12'>
                        <FormItem prop='' label='预订人：' :label-width='120'>
                            <div>{{transactionListData.creator}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='入住人：' :label-width='120'>
                            <div>{{transactionListData.roomOfPersion}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='酒店：' :label-width='120'>
                            <div>{{transactionListData.hotelName}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='酒店地址：' :label-width='120'>
                            <div>{{hotelDetail.CityName + hotelDetail.DistrictName + transactionListData.address}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='房型产品：' :label-width='120'>
                            <div>{{transactionListData.roomName}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='房源：' :label-width='120'>
                            <div>艺龙</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='房间数量：' :label-width='120'>
                            <div>{{transactionListData.numOfRooms}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='入离日期：' :label-width='120'>
                            <div>{{`${transactionListData.arrivalDate} - ${transactionListData.departureDate}`}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='入住晚数：' :label-width='120'>
                            <div>{{transactionListData.nightNum}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='预计到店时间：' :label-width='120'>
                            <div>{{`${transactionListData.earliestArrivalTime} - ${transactionListData.latestArrivalTime}`}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='免费取消时间：' :label-width='120'>
                            <div>{{transactionListData.freeCancelTime}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='最晚取消时间：' :label-width='120'>
                            <div>{{transactionListData.cancelTime}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='发票信息：' :label-width='120'>
                            <div>{{
                                {
                                    Elong: '发票由Xbed开具',
                                    Hotel: '发票由酒店开具'
                                }[transactionListData.invoiceMode] || ''
                                }}</div>
                        </FormItem>
                    </Col>
                </Row>
                <div class='page-title'>
                    <span>支付信息</span>
                </div>
                <Row>
                    <Col span='12'>
                        <FormItem prop='' label='订单应付：' :label-width='120'>
                            <div>{{transactionListData.totalPrice || 0}}元</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='支付状态：' :label-width='120'>
                            <div>{{['未支付','已支付','待退款','已退款','支付失败'][transactionListData.payStatus]}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='实付：' :label-width='120'>
                            <div>{{transactionListData.payPrice || 0}}元</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='取消罚金：' :label-width='120'>
                            <div>{{transactionListData.penaltyAmount || 0}}元</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='待退金额：' :label-width='120'>
                            <div>{{transactionListData.backAmount || 0}}元</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='取消原因：' :label-width='120'>
                            <div>{{transactionListData.reasonOfCancel}}</div>
                        </FormItem>
                    </Col>
                    <Col span='12'>
                        <FormItem prop='' label='退款金额：' :label-width='120'>
                            <div>{{transactionListData.refundAmount || '0.00'}}元</div>
                        </FormItem>
                    </Col>
                </Row>
                <div class='page-title'>
                    <span>交易流水</span>
                </div>
                <Table stripe :loading='transactionLoading' :width="tableWidth" height="550" :columns="transactionList" :data="transactionListData.tradeList">
                </Table>
            </Form>
        </section>
        <Modal
            v-model="isCancelOrderShow"
            title="取消订单"
            @on-ok="cancelOrder"
            @on-cancel="closeCancelOrder">
            <p>确认取消订单？</p>
            <p>取消可能产生扣罚，剩余金额将自动原路退款。</p>
            <p style='fontSize: 15px;padding:10px 0;'>请填写退款原因</p>
            <Input type='textarea' v-model='cancelText' :value='cancelText'></Input>
        </Modal>
        <Modal
            v-model="isContralShow"
            title="操作记录"
            okText="关闭"
            cancelText=""
            @on-ok="cancelContral" >
            <div v-for='item of controlHistory' :key='item.ctime' class='contralStyle'>
                <div class='control-left'>{{timeFormat(item.ctime)}}</div>
                <div class='control-right'>
                    <p>操作类型：{{item.operationType}}</p>
                    <p>{{item.content}}</p>
                    <p>备注：{{item.remark}}</p>
                    <p>操作人：{{`${item.systemName}/${item.operatorName}`}}</p>
                </div>
            </div>
        </Modal>
    </article>
</template>
<script>
import API from "../../api";
import Moment from 'moment';
import Utils from '../../utils';

export default{
   
    created(){
        this.token = Utils.findFromLocalStorage('vue-token');
        this.env = Utils.findFromLocalStorage('env','dev');
        this.username = Utils.findFromLocalStorage("vue-username");
        this.userId = Utils.findFromLocalStorage('vue-userid');
        this.tableWidth = window.screen.width - 235;
        if(!Utils.hasPermission('Elong_elongOrderDetail_CancelOrder')){
            this.isShowCancelBtn = false;
        }
    },
    async mounted(){
       this.getOrderDetail();
    },
    data(){
        return{
            isShowCancelBtn: true,
            tableWidth: 0,
            isContralShow:false,  // 是否展示操作记录弹窗
            cancelText:'',        // 取消的原因
            isCancelOrderShow: false, // 是否展示取消订单弹窗
            controlHistory: [],     // 操作记录
            transactionLoading: false,  // 交易loading展示
            transactionListData:{       // 交易列表
                tradeList:[],
                isCanClick: true,  // 是否可以点击
            },
            hotelDetail:{
                CityName: '',
                DistrictName: ''
            },
            spinShow: false,       // loading
            transactionList:[       // 交易列表信息
                {
                    title:'交易类型',
                    key:'tradeType',
                    minWidth:150,
                    align: 'center',
                    render:(h,params)=>{
                        let type = ['','支付','退款'][params.row.tradeType];
                        return h('div',{},type)
                    }
                },
                {
                    title:'交易单号',
                    key:'tradeNo',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易时间',
                    key:'tradeTime',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'交易状态',
                    key:'payStatus',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'支付方式',
                    key:'sourceType',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'金额',
                    key:'amount',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'第三方流水号',
                    key:'outNo',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'备注',
                    key:'remark',
                    minWidth:150,
                    align: 'center',
                }
            ],
        }
    },
    methods:{
        // 打开取消订单弹出层
        openCancelOrder(){
            this.isCancelOrderShow = true;
        },
        // 关闭取消订单弹出层
        closeCancelOrder(){
            this.isCancelOrderShow = false;
        },
        // 打开操作记录弹出层
        async openContral(){
            this.isContralShow = true;
            this.getContral();
        },
        // 关闭操作记录弹出层
        cancelContral(){
            this.isContralShow = false;
        },
        // 时间格式化
        timeFormat(time){
            return Moment(time).format('YYYY-MM-DD HH:mm:ss');
        },
        // 取消订单
        async cancelOrder(){

            if(!this.cancelText){
                this.$Notice.info({
                    title:'取消订单失败',
                    desc:'请填写取消原因'
                });
                return ''
            }
            let  params= {
                operator_id: this.userId || '469',
                operator_name: this.username,
                order_id: this.transactionListData.orderId,
                reason: this.cancelText
            }
            this.$Spin.show();
            let respData = (await API.omsAPI[this.env].elong.elongOrderCancel(params,this.token)).data;
            let title = respData.retCode == 200 ? '订单取消成功' : '订单取消失败'
            this.$Spin.hide();
            this.$Notice.info({
                title: title,
                desc: respData.msg
            });
            
            this.getOrderDetail();
            console.info(respData);
        },
        // 获取操作记录
        async getContral(){
            let respData = (await API.omsAPI[this.env].elong.elongOrderContral(this.orderId,this.token)).data;
            this.controlHistory = respData.data;
        },

        // 获取订单详情
        async getOrderDetail(){
            this.transactionLoading = true;
            let orderId = Utils.getUrlParameterByName('orderId');
            this.orderId = orderId;
            let respData = (await API.omsAPI[this.env].elong.elongOrderDetail(orderId,this.token)).data;
            this.transactionListData = respData.data;
            this.hotelDetail = JSON.parse(respData.data.hotelDetailInfo.replace(/\s/g,' ')).hotelDetail;
            this.transactionLoading = false;
            this.transactionListData.isCanClick = this.transactionListData.status === 1 ? false : true;
            // this.$set(this.transactionListData,'isCanClick', this.transactionListData.status == 1 ? false : true );
        }
    }
}
</script>
<style>
.page-title{
    font-size: 20px;
    background-color: #ddd;
    padding: 10px;
    margin-bottom: 20px;
}
.contralStyle{
    width:100%;
    overflow: auto;
    display:flex;
}
.control-left{
    width: 35%;
    text-align: right;
}
.control-right{
    width: 65%;
    text-align: left;
    padding-left:10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/elong/orderDetail.vue